import { useContext } from "react";
import { StepsContext } from "contexts";

export const useSteps = () => {
  const [steps, dispatch] = useContext(StepsContext);

  /**
   *  Go to the next step.
   */
  const nextStep = () => {
    dispatch({
      type: "nextStep",
    });
  };

  /**
   *  Go to the previous step.
   */
  const previousStep = () => {
    dispatch({
      type: "previousStep",
    });
  };

  /**
   *  Set the success state.
   *
   *  @param {string} stepName
   */

  // const setSuccess = (stepName) => {
  //   // let success = {};
  //   // success[stepName] = true;

  //   dispatch({
  //     type: "setSuccess",
  //     payload: stepName,
  //   });
  // };

  /**
   *  Set the completed state.
   *
   *  @param {string} stepName
   */

  const setCompleted = (stepName) => {
    // let success = {};
    // success[stepName] = true;

    dispatch({
      type: "setCompleted",
      payload: stepName,
    });
  };

  /**
   *  Set the error state.
   *
   *  @param {object} step
   */
  const setError = (error) => {
    dispatch({
      type: "setError",
      payload: error,
    });
  };

  return {
    steps: steps,
    //    setSuccess: setSuccess,
    setError: setError,
    previousStep: previousStep,
    nextStep: nextStep,
    setCompleted: setCompleted,
  };

  //  return [steps, setSuccess, setError, previousStep, nextStep];
};
